/* wnfsw-product: progressive enhancement for the product story below the buy box (WNF Sunflower sweep 2026-10-04).
   Chat buttons open the site chat in place; the description toggle; the lede, delivery tier and in-stock lines follow the
   selected variant; a phone-only docked bar clicks the real Add to Cart (no cart logic of its own) and stays out of the zone
   from the product title to the bottom of the real Add to Cart; the empty-recommendations fallback; consent-gated GA4 events.
   The section works without this file. */
(() => {
  'use strict';
  if (window.wnfswProductInit) return;
  window.wnfswProductInit = true;
  const MID = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const decode = (s) => String(s || '').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  const init = () => {
    const root = document.querySelector('[data-wnfsw-product-page]');
    if (!root) return;
    const gate = root.dataset.gate || '';
    const track = (name, params = {}) => {
      if (!allowed() || typeof window.gtag !== 'function') return;
      window.gtag('event', name, { send_to: MID, page_location: location.origin + location.pathname, product_gate: gate, ...params });
    };
    let data = { map: {}, variants: {} };
    try { data = JSON.parse(root.querySelector('[data-wnfsw-data]')?.textContent || '{}') || data; } catch (e) { /* keep defaults */ }
    const map = data.map || {};

    // Clicks: capture phase so this runs before Motion's link handler starts a page transition.
    document.addEventListener('click', (event) => {
      const t = event.target;
      const cta = t.closest?.('[data-wnfsw-cta]');
      if (cta && root.contains(cta)) track('wnf_product_cta_click', { cta_placement: cta.dataset.wnfswCta, transport_type: 'beacon' });
      const chat = t.closest?.('[data-wnfsw-chat]');
      if (chat && root.contains(chat) && typeof window.WNFChatOpen === 'function') {
        event.preventDefault();
        const intent = chat.dataset.wnfswChat;
        window.WNFChatOpen(intent === 'photo' ? { intent: 'photo' } : undefined);
        track('wnf_product_chat_open', { intent });
      }
      const more = t.closest?.('[data-wnfsw-more]');
      if (more && root.contains(more)) {
        const body = root.querySelector('[data-wnfsw-clamp]');
        const open = body.classList.toggle('is-open');
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? 'Show less' : 'Read the full description';
      }
    }, true);

    // The lede, delivery tier, try-at-home line and the bar label follow the selected variant.
    const bar = root.querySelector('[data-wnfsw-sticky]');
    const money = (cents) => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    const fitPrice = () => {
      // Show the price only while the label keeps at least 12 visible characters.
      if (!bar) return;
      const label = bar.querySelector('[data-wnfsw-sticky-label]');
      const price = bar.querySelector('[data-wnfsw-sticky-price]');
      if (!label || !price) return;
      bar.classList.remove('is-tight');
      const text = label.textContent || '';
      if (!text || label.scrollWidth <= label.clientWidth) return;
      const perChar = label.scrollWidth / text.length;
      if (label.clientWidth / perChar < 12) bar.classList.add('is-tight');
    };
    const sync = (variant) => {
      if (!variant) return;
      const price = Number(variant.price) || 0;
      const tier = price >= 500000 ? 'oregon' : price >= 150000 ? 'local' : 'under';
      root.querySelectorAll('[data-wnfsw-tier]').forEach((el) => { el.hidden = el.dataset.wnfswTier !== tier; });
      const inStock = !!variant.available && map[String(variant.id)]?.state === 'in_stock';
      root.querySelectorAll('[data-wnfsw-if="in_stock"]').forEach((el) => { el.hidden = !inStock; });
      const v = data.variants?.[String(variant.id)];
      const lede = root.querySelector('[data-wnfsw-lede]');
      if (lede && v && v.s) lede.textContent = decode(v.s);
      if (bar && bar.querySelector('[data-wnfsw-sticky-label]')) {
        bar.querySelector('[data-wnfsw-sticky-label]').textContent = v && v.t ? decode(v.t) : '';
        bar.querySelector('[data-wnfsw-sticky-price]').textContent = money(price);
        fitPrice();
      }
    };
    document.addEventListener('variantChange', (event) => {
      if (!event.target?.closest?.('[data-section-type="product"]')) return;
      sync(event.detail?.variant);
      updateBar();
    }, true);

    // Phone bar: hidden from the top of the product title to the bottom of the real Add to Cart (the product form in chat
    // and link modes), hidden near the footer, shown otherwise. Docked full width; html.wnfsw-sticky-on lifts the chat launcher.
    const product = document.querySelector('[data-section-type="product"]');
    const form = product?.querySelector('form[action$="/cart/add"]');
    const real = form?.querySelector('button[name="add"]');
    const mode = bar?.dataset.mode || 'cart';
    const zoneTopEl = product?.querySelector('h1');
    const zoneEndEl = mode === 'cart' ? real : (form || product?.querySelector('[data-product-blocks]'));
    const footer = document.getElementById('shopify-section-wnf-site-footer');
    const phone = window.matchMedia('(max-width: 899px)');
    let shown = null;
    function updateBar() {
      if (!bar || !zoneEndEl || (mode === 'cart' && !real)) return;
      const vh = window.innerHeight;
      const top = zoneTopEl ? zoneTopEl.getBoundingClientRect().top : zoneEndEl.getBoundingClientRect().top;
      const bottom = zoneEndEl.getBoundingClientRect().bottom;
      // wnf-pdp-10x-2026-10-11: desktop gets the bar too, but only once the whole buy area (pinned photo included) has
      // scrolled away, so it never covers the gallery; it sits centered as a compact bar (wnfsw-product.css).
      const inZone = phone.matches ? bottom > 0 && top < vh : product.getBoundingClientRect().bottom > 80;
      const nearFooter = footer ? footer.getBoundingClientRect().top < vh : false;
      const show = !inZone && !nearFooter && !(mode === 'cart' && real.disabled);
      if (show === shown) return;
      shown = show;
      bar.hidden = !show;
      document.documentElement.classList.toggle('wnfsw-sticky-on', show);
      if (show && mode === 'cart') {
        const label = (real.textContent || '').replace(/\s+/g, ' ').trim();
        bar.querySelector('[data-wnfsw-sticky-add]').textContent = label && label.length < 24 ? label : 'Add to cart';
        fitPrice();
      }
    }
    if (bar) {
      let ticking = false;
      const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; updateBar(); }); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      phone.addEventListener?.('change', onScroll);
      if (real && mode === 'cart') new MutationObserver(() => { shown = null; updateBar(); }).observe(real, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      if (mode === 'cart' && real) bar.querySelector('[data-wnfsw-sticky-add]').addEventListener('click', () => {
        track('wnf_product_sticky_add');
        if (real.disabled) { real.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        real.click();
      });
      updateBar();
    }

    // A theme script turns some description headings (e.g. "Care") into Motion collapsible buttons. In this section the
    // description is plain reading text, so put each one back as a heading with its content inline.
    const unfold = () => {
      root.querySelectorAll('.wnfsw-rte .collapsible-trigger-btn').forEach((btn) => {
        const block = btn.closest('.wnfsw-rte .product-block') || btn.closest('.collapsibles-wrapper') || btn.parentElement;
        const inner = block.querySelector('.collapsible-content__inner') || block.querySelector('.collapsible-content');
        const h = document.createElement('h4');
        h.textContent = (btn.textContent || '').replace(/\s+/g, ' ').trim();
        const frag = document.createDocumentFragment();
        frag.append(h);
        if (inner) frag.append(...inner.childNodes);
        block.replaceWith(frag);
      });
    };
    unfold();
    root.querySelectorAll('.wnfsw-rte').forEach((el) => new MutationObserver(() => { if (el.querySelector('.collapsible-trigger-btn')) unfold(); }).observe(el, { childList: true, subtree: true }));

    // Empty recommendations: after load, show the fallback links when the row below has no product cards.
    const fallback = root.querySelector('[data-wnfsw-recs-empty]');
    const checkRecs = () => {
      const recs = document.querySelector('[id$="__product-recommendations"]');
      const cards = recs ? recs.querySelectorAll('a[href*="/products/"]').length : 0;
      if (fallback) fallback.hidden = cards > 0;
      root.querySelectorAll('[data-wnfsw-recs-link]').forEach((a) => { a.hidden = cards === 0; });
    };
    if (document.readyState === 'complete') setTimeout(checkRecs, 2500);
    else window.addEventListener('load', () => setTimeout(checkRecs, 2500), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
